export default __webpack_public_path__ + "static/media/dark_2_placeholder.6e86a85f.jpg";